export const products = [
  {
    id: 1,
    name: "Visiting Cards",
    description: "Professional business cards with premium quality",
    image: "/products/visitingcard.png"
  },
  {
    id: 2,
    name: "ID Cards & Lanyards",
    description: "Employee identification cards and branded lanyards",
    image: "/products/id-cards.png"
  },
  {
    id: 3,
    name: "Letterheads",
    description: "Professional letterhead printing",
    image: "/products/letterheads.png"
  },
  {
    id: 4,
    name: "Envelopes",
    description: "Custom printed envelopes",
    image: "/products/envelopes.png"
  },
  {
    id: 5,
    name: "Brochures",
    description: "High quality brochure printing",
    image: "/products/brochures.png"
  },
  {
    id: 6,
    name: "Presentation Folders",
    description: "Corporate meeting folders",
    image: "/products/presentation-folder.png"
  },
  {
    id: 7,
    name: "Pamphlets",
    description: "Promotional flyers and pamphlets",
    image: "/products/pamphlets.png"
  },
  {
    id: 8,
    name: "Standees",
    description: "Rollup standee banners",
    image: "/products/standees.png"
  },
  {
    id: 9,
    name: "Corporate Gifting",
    description: "Custom corporate gifts",
    image: "/products/corporate-gifting.png"
  }
];

export const testimonials = [
  {
    id: 1,
    stars: 5,
    quote: "Mahadev Printers has been our go-to partner for all corporate printing needs. Their attention to detail and timely delivery is unmatched.",
    name: "Sandeep Pendse",
    title: "Head administration- Indusind General Insurance Company ltd"
  },
  {
    id: 2,
    stars: 5,
    quote: "The quality of prints is exceptional. From business cards to large format banners, everything is perfect. Highly professional service!",
    name: "Santosh Parab",
    title: "Sbicaps Securities Ltd"
  },
  {
    id: 3,
    stars: 5,
    quote: "Fast turnaround time and excellent customer support. They understand corporate requirements and deliver beyond expectations every time.",
    name: "Alok Prasad",
    title: "Nippon India Mutual Funds Ltd"
  }
];

export const clients = [
  {
    id: 1,
    name: "IndusInd General Insurance",
    logo: "https://customer-assets.emergentagent.com/job_printpure/artifacts/y858a3zl_image.png"
  },
  {
    id: 2,
    name: "IndusInd Securities Ltd",
    logo: "https://customer-assets.emergentagent.com/job_printpure/artifacts/jab446c4_Screenshot%202026-04-11%20at%201.33.21%E2%80%AFPM.png"
  },
  {
    id: 3,
    name: "IndusInd Capital Ltd",
    logo: "https://customer-assets.emergentagent.com/job_printpure/artifacts/mztg5e8q_Screenshot%202026-04-11%20at%201.33.23%E2%80%AFPM.png"
  },
  {
    id: 4,
    name: "SBICap Securities Ltd",
    logo: "https://customer-assets.emergentagent.com/job_printpure/artifacts/c27h38ho_Screenshot%202026-04-11%20at%201.33.27%E2%80%AFPM.png"
  },
  {
    id: 5,
    name: "TruHome Finance Limited",
    logo: "https://customer-assets.emergentagent.com/job_printpure/artifacts/kb8jjz3y_Screenshot%202026-04-11%20at%201.33.31%E2%80%AFPM.png"
  },
  {
    id: 6,
    name: "Aadhaar Housing Finance Ltd",
    logo: "https://customer-assets.emergentagent.com/job_printpure/artifacts/h5zf7x27_Screenshot%202026-04-11%20at%201.33.35%E2%80%AFPM.png"
  },
  {
    id: 7,
    name: "Niwas Housing Finance Ltd",
    logo: "https://customer-assets.emergentagent.com/job_printpure/artifacts/knuqjmuj_Screenshot%202026-04-11%20at%201.33.39%E2%80%AFPM.png"
  },
  {
    id: 8,
    name: "Protium Finance Limited",
    logo: "https://customer-assets.emergentagent.com/job_printpure/artifacts/udlejfvu_Screenshot%202026-04-11%20at%201.33.43%E2%80%AFPM.png"
  },
  {
    id: 9,
    name: "SMFG India Credit Finance Ltd",
    logo: "https://customer-assets.emergentagent.com/job_printpure/artifacts/espy89ar_Screenshot%202026-04-11%20at%201.33.45%E2%80%AFPM.png"
  },
  {
    id: 10,
    name: "Nippon India Mutual Fund",
    logo: "https://customer-assets.emergentagent.com/job_printpure/artifacts/w6zzkllx_Screenshot%202026-04-11%20at%201.33.48%E2%80%AFPM.png"
  }
];

export const navLinks = [
  { label: "Home", href: "#home" },
  { label: "Services", href: "#services" },
  { label: "About Us", href: "#about" },
  { label: "Contact", href: "#contact" }
];
